import { render, staticRenderFns } from "./SectionTitle.vue?vue&type=template&id=ea3e53dc&scoped=true"
import script from "./SectionTitle.vue?vue&type=script&lang=js"
export * from "./SectionTitle.vue?vue&type=script&lang=js"
import style0 from "./SectionTitle.vue?vue&type=style&index=0&id=ea3e53dc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea3e53dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea3e53dc')) {
      api.createRecord('ea3e53dc', component.options)
    } else {
      api.reload('ea3e53dc', component.options)
    }
    module.hot.accept("./SectionTitle.vue?vue&type=template&id=ea3e53dc&scoped=true", function () {
      api.rerender('ea3e53dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/synthesize/officialDocProcess/components/SectionTitle.vue"
export default component.exports